import React from 'react';
import { ASSETS, STATS } from '../mock';

const OurStory = () => {
  return (
    <section className="relative bg-fnl-dark py-24 px-6 md:px-12 overflow-hidden">
      {/* Decorative gradient blobs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-fnl-pink/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-700/30 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-fnl-pink font-semibold text-sm tracking-wider uppercase mb-3">Our Story</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white max-w-3xl mx-auto leading-tight">
            We are extremely satisfied to provide a safe and entertaining platform for our adult users to enjoy
          </h2>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 gap-6 md:gap-12 mb-16 max-w-3xl mx-auto">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="bg-fnl-purple/60 backdrop-blur-sm border border-purple-800/40 rounded-2xl p-8 text-center card-hover"
            >
              <img src={stat.icon} alt="" className="w-12 h-12 mx-auto mb-4" />
              <div className="text-4xl md:text-5xl font-extrabold text-fnl-pink mb-1">{stat.value}</div>
              <div className="text-purple-200 text-sm uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Women images row */}
        <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          {[ASSETS.woman1, ASSETS.woman2, ASSETS.woman3].map((img) => (
            <div
              key={img}
              className="relative rounded-2xl overflow-hidden aspect-[3/4] group cursor-pointer"
            >
              <img
                src={img}
                alt="Member"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-fnl-dark/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity">
                <img src={ASSETS.smallHeart} alt="" className="w-6 h-6" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurStory;
